import { Button, Layout, Modal, Space, theme, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { IoAddSharp } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";
import routes from "../../../engine/routes";
import { clearInterpretes, getInterpretes } from "../Slices/InterpretesSlice";
import CustomTable from "../../../shared/components/CustomTable";
import {
  languagesList,
  renderUserFirstname,
  renderUserGenderShort,
  renderUserLanguagesLong,
  renderUserLastname,
  renderUserName,
  roles,
  subStatus,
} from "../../../utils/constants";
import { AiFillCalendar, AiFillFileExcel } from "react-icons/ai";
import { TbFileTypeXml } from "react-icons/tb";
import {
  createXMLString,
  createXMLWages,
  downloadXML,
} from "../../../utils/bills.xml";
import { http } from "../../../engine/api/http";
import { userHasLevel } from "../../../engine/AuthRoute";
import LogHistory from "../../../shared/components/LogHistory";

const { Content, Sider, Header, Footer } = Layout;

export function InterpretesList(props) {
  const { interpretes, loading } = useSelector(state => state.interpretes);
  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [search, setSearch] = useState("");
  const [languageSearch, setLanguageSearch] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loadingExport, setLoading] = useState(false);

  const onSelectChange = r => {
    setSelectedRowKeys(r);
  };

  // const context = useContext(AppContext);
  const {
    token: { colorBgLyout },
  } = theme.useToken();

  useEffect(() => {
    dispatch(getInterpretes());

    return () => {
      dispatch(clearInterpretes());
    };
  }, []);

  const columns = [
    {
      title: "N°",
      render: (a, record) => record.interpreteData.abacusId || "-",
      key: "f",
      sorter: (a, b, c) => {
        const getOrderWeight = item => {
          if (
            item.interpreteData.abacusId !== null &&
            item.interpreteData.abacusId !== undefined
          ) {
            return item.interpreteData.abacusId;
          } else {
            if (c === "ascend") {
              return 9999999999999999;
            } else {
              return -1; // Prioritize null or undefined
            }
          }
        };
        const idA = getOrderWeight(a);
        const idB = getOrderWeight(b);

        return idA - idB; // For ascending order (and default case)
      },
    },
    {
      title: "Nom",
      render: (n, record) => renderUserLastname(record),
      width: "15%",
      key: "nom",
      sorter: (a, b) => {
        return a.info.lastname.localeCompare(b.info.lastname);
      },
    },
    {
      title: "Prénom",
      render: (n, record) => renderUserFirstname(record),
      width: "15%",
      key: "Prénom",
      sorter: (a, b) => {
        return a.info.firstname.localeCompare(b.info.firstname);
      },
    },
    {
      title: "Genre",
      render: (n, record) => renderUserGenderShort(record),
      key: "Genre",
      width: 100,
      sorter: (a, b) => {
        const genreA = a?.info?.genre || "";
        const genreB = b?.info?.genre || "";
        return genreA.localeCompare(genreB);
      },
    },
    {
      title: "Email",
      width: "25%",
      dataIndex: "email",
      sorter: (a, b) => {
        return a.email.localeCompare(b.email);
      },
    },
    {
      title: "Langues interprétées",
      render: (info, u) => renderUserLanguagesLong(u),
    },
    {
      title: "Accés autorisé",
      width: "15%",
      render: (status, u) => {
        return <span>{status === "inactive" ? "Non" : "Oui"}</span>;
      },
      dataIndex: "status",
      sorter: (a, b) => {
        return a.status.localeCompare(b.status);
      },
    },
  ];

  const inputs = [
    {
      parentLabel: null,
      children: [
        {
          label: "Recherche générale",
          placeholder:
            "Numéro d'interprète, Nom & Prénom, Email, Adresse, Téléphone",
          name: "search",
          value: "",
          type: "input",
          capitalize: false,
          col: 12,
        },
        {
          label: "Filtre par langue",
          name: "langue",
          type: "select",
          value: [],
          showSearch: true,
          allowClear: true,
          reset: true,
          multiple: true,
          selectContent: languagesList.sort((a, b) =>
            a.label.localeCompare(b.label),
          ),
          col: 12,
        },
      ],
    },
  ];

  const onValuesChange = changedValues => {
    Object.keys(changedValues).map(changed => {
      switch (changed) {
        case "search":
          setSearch(changedValues[changed]);
          break;
        case "langue":
          setLanguageSearch(changedValues[changed]);
          break;
      }
    });
  };

  // const searchFilterData = () => {
  //   let copy = interpretes;
  //
  //   if (languageSearch.length > 0) {
  //     copy = copy.filter(interprete =>
  //         languageSearch.every(language =>
  //             interprete.interpreteData.languages.includes(language)
  //         )
  //     );
  //   }
  //
  //   if (search.length > 0) {
  //     const searchLowerCase = search.toLowerCase();
  //
  //     copy = copy.filter(interprete =>
  //         [
  //           interprete.info.firstname.toLowerCase(),
  //           interprete.email.toLowerCase(),
  //           interprete.interpreteData.address.toLowerCase(),
  //           interprete.interpreteData.addressStart.toLowerCase(),
  //           interprete.info.phone.toLowerCase(),
  //           interprete.info.lastname.toLowerCase()
  //         ].some(field => field.includes(searchLowerCase))
  //     );
  //   }
  //
  //   return copy;
  // };
  // Short function optimize by IA

  const searchFilterData = () =>
    interpretes.filter(interprete => {
      const { info, email, interpreteData } = interprete;
      const { firstname, lastname } = info;
      const { addressStart, languages, abacusId } = interpreteData;
      const searchLowerCase = search.toLowerCase();

      let hasLanguage =
        languageSearch.length === 0 ||
        languageSearch.some(language => languages.includes(language));

      const hasSearchMatch = [
        String(abacusId),
        firstname,
        lastname,
        email,
        addressStart,
      ].some(field => field.toLowerCase().includes(searchLowerCase));

      return hasLanguage && (search.length === 0 || hasSearchMatch);
    });

  let copy2 = searchFilterData();

  const exportWages = async () => {
    try {
      setLoading(true);

      // setShowModal(!showModal);

      const data = formRef.current.getFieldsValue(true);

      const loggit = await http.post("/logs", {
        baseUrl: "/api/users",
        action: "export",
        route: "/api/users/wages",
        ressource: "/api/users/wages",
        content: {
          interpreteIds: selectedRowKeys,
          ...data,
        },
      });

      const response = await http.post("bills/wages", {
        interpretes: selectedRowKeys,
        ...data,
      });

      const wages = response.data;

      const xmlString = createXMLWages({
        wages,
        year: data.year,
        month: data.month,
      });
      downloadXML(xmlString, `salaires_${data.year}_${data.month}.xml`);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const yearslabelsArray = () => {
    // add each year since 2023 and the current year by date
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 2023; i <= currentYear; i++) {
      years.push({ value: i, label: i });
    }
    return years;
  };

  const inputsModalDates = [
    {
      parentLabel: "",
      children: [
        {
          name: "year",
          label: "Année",
          required: true,
          type: "select",
          value: new Date().getFullYear(),
          col: 24,
          selectContent: yearslabelsArray(),
        },
        {
          name: "month",
          col: 24,
          label: "Mois",
          type: "select",
          value: `0${new Date().getMonth() + 1}`,
          required: true,
          selectContent: [
            { value: "01", label: "janvier" },
            { value: "02", label: "février" },
            { value: "03", label: "mars" },
            { value: "04", label: "avril" },
            { value: "05", label: "mai" },
            { value: "06", label: "juin" },
            { value: "07", label: "juillet" },
            { value: "08", label: "août" },
            { value: "09", label: "septembre" },
            { value: "10", label: "octobre" },
            { value: "11", label: "novembre" },
            { value: "12", label: "décembre" },
          ],
        },
      ],
    },
  ];

  return (
    <Content>
      <LogHistory
          linkType={"detail"}
        route={"/api/users/wages"}
        label={"Exportation des salaires la plus récente"}
      />
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          Interprètes
        </Typography.Title>

        <Space>
          <Link to={routes.interpretes("new").detail.path}>
            <Button
              size={"large"}
              type={"primary"}
              style={{
                justifySelf: "flex-start",
                display: "flex",
              }}
              icon={
                <IoAddSharp
                  style={{
                    marginTop: "0px",
                  }}
                  size={25}
                />
              }
            >
              {routes.interpretes().new.title}
            </Button>
          </Link>
          <Button
            disabled={selectedRowKeys.length === 0 || loadingExport}
            loading={loadingExport}
            style={{
              justifySelf: "flex-start",
              display: "flex",
            }}
            size={"large"}
            onClick={() => setShowModal(!showModal)}
            icon={
              <TbFileTypeXml
                style={{
                  marginTop: "0px",
                }}
                size={25}
              />
            }
          >
            Exporter les salaires
          </Button>
        </Space>
      </Space>

      <CustomForm
        style={{
          flex: 1,
          maxWidth: 1200,
          paddingRight: 20,
        }}
        dataSource={inputs}
        labelCol={24}
        wrapperCol={24}
        rowSelectedKeys={selectedRowKeys}
        onValuesChange={onValuesChange}
      />
      <CustomTable
        onSelectChange={onSelectChange}
        loading={loading}
        hasSelection={true}
        smTitle={item => {
          return (
            <div className={"alignHeaderPage"}>
              <h2 className={"noMargin"}>{renderUserName(item)}</h2>
            </div>
          );
        }}
        onRowLink={record => routes.interpretes(record._id).detail.path}
        hasPagination={true}
        pagination={{
          hideOnSinglePage: true,
          position: ["topRight"],
          defaultPageSize: 100,
          pageSizeOptions: [10, 20, 50, 100],
          showSizeChanger: true,
        }}
        dataSource={copy2}
        columns={columns}
        rowKey="_id"
      />
      <Modal
        open={showModal}
        title={"Sélectionner la période"}
        okText={"Exporter les salaires"}
        onOk={exportWages}
        okButtonProps={{ loading: loadingExport }}
        onCancel={() => setShowModal(!showModal)}
      >
        <CustomForm
          dataSource={inputsModalDates}
          refForm={formRef}
          style={{
            flex: 1,
            maxWidth: 1200,
            paddingRight: 20,
          }}
          labelCol={24}
          wrapperCol={24}
        ></CustomForm>
      </Modal>
    </Content>
  );
}
